(function () {
    if (!customElements.get("nss-bundle")) {
        customElements.define("nss-bundle", class LSGBundle extends HTMLElement {
            constructor() {
                super();
                this.selectors = {
                    atcButton: ".js-nss-bundle-submit-button",
                    quantityInput: ".js-nss-bundle-product-quantity-input",
                    productsAdd: ".js-nss-bundle-product-btn",
                    product: ".js-nss-bundle-product",
                    quantityControlPlus: ".js-nss-bundle-product-quantity-control-plus",
                    quantityControlMinus: ".js-nss-bundle-product-quantity-control-minus",
                    productPrice: ".js-nss-bundle-product-price",
                    resultProducts: ".js-nss-bundle-results",
                    totalComparePrice: ".js-nss-bundle-total-price-compare",
                    totalRegularPrice: ".js-nss-bundle-total-price-regular",
                    discount: ".js-nss-bundle-discount",
                    sellingOption: ".js-nss-bundle-selling-option",
                    frequencySelect: ".js-nss-bundle-frequency-select",
                    sellingPlanInput: 'input[name="selling_plan"]',
                    progressMin: ".js-nss-bundle-progress-min",
                    progressSteps: ".js-nss-bundle-progress-steps",
                    progressStep: ".js-nss-bundle-discounts-step",
                    stickyBtnToggle: ".js-nss-bundle-sticky-btn-toggle",
                    totalProducts: ".js-nss-bundle-total-products",
                    bundleRadio: ".js-bundle-radio",
                    // Preview Selectors Restored
                    totalSubComparePrice: ".js-nss-bundle-total-sub-price-compare",
                    totalSubRegularPrice: ".js-nss-bundle-total-sub-price",
                    totalOTPComparePrice: ".js-nss-bundle-total-otp-price-compare",
                    totalOTPRegularPrice: ".js-nss-bundle-total-otp-price",
                    bundleHeading: ".js-bundle-heading",
                    sidebar: ".js-bundle-sidebar",
                    sidebarToggle: ".js-bundle-sidebar-toggle",

                };
                this.classes = {
                    isNotActive: "is-not-active",
                    isEmpty: "is-empty",
                    isActive: "is-active"
                }
            }

            connectedCallback() {
                this.dataDiscounts = JSON.parse(this.getAttribute("data-discounts"));
                this.resultProductsData = JSON.parse(this.getAttribute("data-products"));

                if (this.dataDiscounts && this.dataDiscounts.discounts.length > 1) {
                    const secondTier = this.dataDiscounts.discounts[1];
                    this.totalQuantityMax = parseInt(secondTier.quantity_max) || 100;
                } else if (this.dataDiscounts && this.dataDiscounts.discounts.length > 0) {
                    const firstTier = this.dataDiscounts.discounts[0];
                    this.totalQuantityMax = parseInt(firstTier.quantity_max) || 100;
                } else {
                    this.totalQuantityMax = parseInt(this.getAttribute("data-max-quantity"));
                }

                this.totalQuantityMin = parseInt(this.getAttribute("data-min-quantity"));

                this.bundleHeading = this.querySelectorAll(this.selectors.bundleHeading);
                this.atcButton = this.querySelectorAll(this.selectors.atcButton);
                this.products = this.querySelectorAll(this.selectors.product);
                this.productsAdd = this.querySelectorAll(this.selectors.productsAdd);
                this.quantityControlPlus = this.querySelectorAll(this.selectors.quantityControlPlus);
                this.quantityControlMinus = this.querySelectorAll(this.selectors.quantityControlMinus);
                this.discount = this.querySelectorAll(this.selectors.discount);
                this.totalRegularPrice = this.querySelectorAll(this.selectors.totalRegularPrice);
                this.totalComparePrice = this.querySelectorAll(this.selectors.totalComparePrice);
                this.frequencySelect = this.querySelectorAll(this.selectors.frequencySelect);
                this.sellingOption = this.querySelectorAll(this.selectors.sellingOption);
                this.sellingPlanInput = this.querySelector(this.selectors.sellingPlanInput);
                this.progressMin = this.querySelectorAll(this.selectors.progressMin);
                this.progressSteps = this.querySelectorAll(this.selectors.progressSteps);
                this.progressStep = this.querySelectorAll(this.selectors.progressStep);
                this.totalProducts = this.querySelectorAll(this.selectors.totalProducts);
                this.resultProductsContainer = this.querySelector(this.selectors.resultProducts);

                // Restore Preview Price Elements
                this.totalSubComparePrice = this.querySelectorAll(this.selectors.totalSubComparePrice);
                this.totalSubRegularPrice = this.querySelectorAll(this.selectors.totalSubRegularPrice);
                this.totalOTPComparePrice = this.querySelectorAll(this.selectors.totalOTPComparePrice);
                this.totalOTPRegularPrice = this.querySelectorAll(this.selectors.totalOTPRegularPrice);
                this.sidebar = this.querySelector(this.selectors.sidebar);

                this.sidebarToggle= this.querySelectorAll(this.selectors.sidebarToggle);

                this.currencyFormatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});
                this.rechargeCollectionID = parseInt(this.getAttribute("data-recharge-collection-id"));
                this.interval = "otp";
                this.sidebarToggle.forEach(el => el.addEventListener("click", () => {
                    this.sidebar?.classList.toggle("is-active");
                }))
                this.progressStep.forEach(step => {
                    step.addEventListener("click", (e) => {
                        const oldTotalQuantityMax = this.totalQuantityMax
                        this.totalQuantityMax = parseInt(step.getAttribute("data-max"),10);
                        this.setDiscountProgress();
                        if(oldTotalQuantityMax>this.totalQuantityMax){
                            this.products.forEach((product) => {
                                const quantityInput = product.querySelector(this.selectors.quantityInput);
                                quantityInput.value= 0;
                            })
                        }
                                this.updateProducts();
                                this.updateATC();
                                this.setPrices();


                    })
                });
                this.atcButton.forEach(el => {
                    el.addEventListener("click", () => {
                        const inputs = this.querySelectorAll(this.selectors.quantityInput);
                        let rechargeSelections = [];
                        inputs.forEach((input) => {
                            const q = parseInt(input.value);
                            if (q > 0) {
                                const item = {
                                    collectionId: this.rechargeCollectionID,
                                    externalProductId: input.getAttribute('data-external-product-id'),
                                    externalVariantId: input.getAttribute('data-product'),
                                    quantity: q
                                };
                                if (this.interval == 'sub') {
                                    const spgJSON = JSON.parse(input.getAttribute('data-spgs'));
                                    if (spgJSON && this.frequencySelect.length > 0) {
                                        const selectedOption = this.querySelector(`${this.selectors.frequencySelect}`).selectedOptions[0];
                                        if (selectedOption) {
                                            const selectedName = selectedOption.getAttribute("data-name");
                                            const sellingPlan = spgJSON.flatMap(item => item.selling_plans).find(plan => plan.name === selectedName);
                                            if(sellingPlan){
                                                item['sellingPlan'] = parseInt(sellingPlan.id);
                                            }
                                        }
                                    }
                                }
                                rechargeSelections.push(item);
                            }
                        });
                        const rechargeBundleObj = {
                            externalProductId: this.getAttribute('data-recharge-product-id'),
                            externalVariantId: this.getAttribute('data-recharge-variant-id'),
                            selections: rechargeSelections
                        };
                        const payload = recharge.bundle.getDynamicBundleItems(rechargeBundleObj, this.getAttribute('data-recharge-product-handle'));
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({items: payload})
                        }).then(res => {
                            if (res.status == 200) {
                                //window.location.href = "/cart";
                            }
                        });
                    });
                });
                this.frequencySelect.forEach(el => el.addEventListener("change", () => {
                    this.sellingPlanInput.value = el.value;
                    this.setPrices();
                }));
                this.productsAdd.forEach(el => el.addEventListener("click", () => this.updateQuantity(el.closest(this.selectors.product), true)));
                this.quantityControlPlus.forEach(el => el.addEventListener("click", () => this.updateQuantity(el.closest(this.selectors.product), true)));
                this.quantityControlMinus.forEach(el => el.addEventListener("click", () => this.updateQuantity(el.closest(this.selectors.product), false)));
                this.sellingOption.forEach(el => el.addEventListener("change", (e) => {
                    this.interval = e.target.value;
                    this.querySelectorAll(".nss-bundle__interval-option-wrapper").forEach(el=>{
                        el.classList.remove("is-active");
                    });
                    e.target.closest(".nss-bundle__interval-option-wrapper")?.classList.add("is-active");
                    this.setPrices();
                }));
                this.updateProducts();
                this.setPrices();
            }

            getTotalQuantity() {
                let quantity = 0;
                Array.from(this.querySelectorAll(this.selectors.quantityInput)).forEach(ele => {
                    if (ele.value) quantity += parseInt(ele.value, 10);
                });
                return quantity;
            }
            updateQuantity(product, increase, newInputValue) {
                const quantityInput = product.querySelector(this.selectors.quantityInput);
                if (quantityInput != null) {
                    const value = parseInt(quantityInput.value, 10);
                    const max = parseInt(quantityInput.getAttribute("max"));
                    const min = parseInt(quantityInput.getAttribute("min"));
                    const totalQuantity = this.getTotalQuantity();
                    if (increase == true) {
                        const newValue = value + 1;
                        if (newValue <= max && totalQuantity <= this.totalQuantityMax) quantityInput.value = newValue;
                    } else {
                        const newValue = newInputValue != undefined ? newInputValue : value - 1;
                        if (newValue >= 0) quantityInput.value = newValue;
                    }
                    this.updateProducts();
                    this.updateATC();
                    this.setPrices();
                }
            }

            updateProductResult() {
                const container = this.resultProductsContainer;
                if (!container) return;

                let selectedProducts = [];
                let totalCurrentQuantity = 0;

                this.products.forEach(product => {
                    const qtyInput = product.querySelector(this.selectors.quantityInput);
                    const qty = parseInt(qtyInput.value, 10);

                    if (qty > 0) {
                        const id = product.getAttribute('data-product');
                        const meta = this.resultProductsData.find(p => p.id == id);

                        if (meta) {
                            // Instead of grouping, we push one object per unit into the array
                            for (let i = 0; i < qty; i++) {
                                selectedProducts.push({
                                    ...meta,
                                    id: id
                                });
                            }
                            totalCurrentQuantity += qty;
                        }
                    }
                });

                let html = '';

                selectedProducts.forEach(item => {
                    html += `
        <div class="nss-bundle__result js-nss-bundle-result" data-product="${item.id}">
            <button type="button" class="nss-bundle__result-remove js-nss-bundle-result-remove" data-product="${item.id}">
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="20" height="20" rx="10" fill="black"/> <path d="M13.3344 13.418L6.6862 6.76979M13.5259 6.62346L6.8777 13.2716" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/> </svg> 
            </button>
            <div class="nss-bundle__result-media">
                <img src="${item.image}" class="nss-bundle__result-img" alt="${item.title}" loading="lazy">
                
            </div>
            <div class="nss-bundle__result-ttl">${item.title.replace(/\n/g, '<br>')}</div>
        </div>`;
                });

                const emptySlotsCount = Math.max(0, Math.min(this.totalQuantityMax, this.products.length) - totalCurrentQuantity);

                for (let i = 0; i < emptySlotsCount; i++) {
                    html += `
        <div class="nss-bundle__result is-empty">
            <div class="nss-bundle__result-placeholder">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M14.38 8.18H1.85M8.16 1.6V14.13" stroke="#1E1814" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>`;
                }

                container.innerHTML = html;

                container.querySelectorAll('.js-nss-bundle-result-remove').forEach(btn => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault();
                        const productId = btn.getAttribute("data-product");
                        const productEl = this.querySelector(`${this.selectors.product}[data-product="${productId}"]`);
                        const qtyInput = productEl.querySelector(this.selectors.quantityInput);
                        const currentQty = parseInt(qtyInput.value, 10);

                        this.updateQuantity(productEl, false, currentQty - 1);
                    });
                });
            }

            updateATC() {
                const totalQuantity = this.getTotalQuantity();
                if (totalQuantity >= this.totalQuantityMin && totalQuantity <= this.totalQuantityMax) {
                    this.classList.add(this.classes.isActive);
                    this.atcButton.forEach(button => button.removeAttribute("disabled"));
                } else {
                    this.classList.remove(this.classes.isActive);
                    this.atcButton.forEach(button => button.setAttribute("disabled", "disabled"));
                }
            }

            updateProducts() {
                const totalQuantity = this.getTotalQuantity();
                this.products.forEach(product => {
                    const quantityInput = product.querySelector(this.selectors.quantityInput);
                    if (quantityInput != null) {
                        const value = parseInt(quantityInput.value, 10);
                        const qMinus = product.querySelector(this.selectors.quantityControlMinus);
                        const qPlus = product.querySelector(this.selectors.quantityControlPlus);
                        const pAdd = product.querySelector(this.selectors.productsAdd);

                        if (value > 0) product.classList.remove(this.classes.isNotActive);
                        else product.classList.add(this.classes.isNotActive);

                        if (value <= 0) qMinus?.setAttribute("disabled", "disabled");
                        else qMinus?.removeAttribute("disabled");

                        if (totalQuantity >= this.totalQuantityMax) {
                            qPlus?.setAttribute("disabled", "disabled");
                            pAdd?.setAttribute("disabled", "disabled");
                        } else {
                            pAdd?.removeAttribute("disabled");
                            qPlus?.removeAttribute("disabled");
                        }
                    }
                });
                this.updateProductResult();
            }

            setDiscountProgress() {
                const steps = this.querySelectorAll(this.selectors.progressStep);
                let activeIndex = 0;
                steps.forEach((step, index) => {
                    const min = parseInt(step.getAttribute("data-min"), 10);
                    if (this.totalQuantityMax >= min) activeIndex = index;
                    step.classList.remove(this.classes.isActive);
                });
                if (steps[activeIndex]) steps[activeIndex].classList.add(this.classes.isActive);

            }

            setPrices() {
                const totalQuantity = this.getTotalQuantity();
                let discountObjects = this.dataDiscounts?.discounts.filter(item => item.quantity <= totalQuantity);
                let discountObject = discountObjects?.[discountObjects.length - 1] || null;
                let totalQuantityMinThreshold = this.dataDiscounts?.discounts[0].quantity || 0;

                // --- 1. CALCULATE ACTUAL RUNNING TOTALS FOR ALL SELECTED ITEMS ---
                let totalOTP_Base = 0, totalOTP_Final = 0, totalSub_Base = 0, totalSub_Final = 0;

                this.products.forEach(product => {
                    const productPriceWrap = product.querySelectorAll(this.selectors.productPrice);
                    const quantityInput = product.querySelector(this.selectors.quantityInput);
                    const quantity = parseInt(quantityInput.value, 10);

                    if (productPriceWrap.length > 0 && quantityInput != null) {
                        const originPrice = parseInt(productPriceWrap[0].getAttribute("data-price"), 10);

                        // Per-unit OTP Price (Using Math.ceil to get 1235)
                        let unitPriceOTP = originPrice;
                        if (totalQuantity >= totalQuantityMinThreshold && discountObject) {
                            // 1299 * 0.95 = 1234.05 -> Math.ceil = 1235
                            unitPriceOTP = Math.ceil(originPrice * (100 - discountObject.discount) / 100);
                        }

                        // Per-unit Sub Price Base
                        let unitPriceSubBase = originPrice;
                        const spgJSON = JSON.parse(quantityInput.getAttribute('data-spgs'));
                        if (spgJSON && this.frequencySelect.length > 0) {
                            const selectedOption = this.querySelector(`${this.selectors.frequencySelect}`).selectedOptions[0];
                            if (selectedOption) {
                                const selectedName = selectedOption.getAttribute("data-name");
                                const sellingPlan = spgJSON.flatMap(item => item.selling_plans).find(plan => plan.name === selectedName);
                                if (sellingPlan) {
                                    unitPriceSubBase = Math.ceil(originPrice * (100 - sellingPlan.price_adjustments[0].value) / 100);
                                }
                            }
                        }

                        // Per-unit Sub Price Final
                        let unitPriceSubFinal = unitPriceSubBase;
                        if (totalQuantity >= totalQuantityMinThreshold && discountObject) {
                            unitPriceSubFinal = Math.ceil(unitPriceSubBase * (100 - discountObject.discount) / 100);
                        }

                        // Accumulate Totals
                        totalOTP_Base += originPrice * quantity;
                        totalOTP_Final += unitPriceOTP * quantity;
                        totalSub_Base += originPrice * quantity;
                        totalSub_Final += unitPriceSubFinal * quantity;

                        // Update individual product price labels
                        const currentListPrice = originPrice;
                        const currentListNewPrice = (this.interval === 'sub') ? unitPriceSubFinal : unitPriceOTP;

                        productPriceWrap.forEach(el => {
                            if (currentListPrice > currentListNewPrice) {
                                el.innerHTML = `<s>${this.currencyFormatter.format(currentListPrice / 100)}</s> ${this.currencyFormatter.format(currentListNewPrice / 100)}`;
                            } else {
                                el.innerHTML = this.currencyFormatter.format(currentListPrice / 100);
                            }
                        });
                    }
                });

                // --- 2. CALCULATE FALLBACK DEFAULTS (First Product, 1 Unit) ---
                let defaultOTP_Base = 0, defaultOTP_Final = 0, defaultSub_Base = 0, defaultSub_Final = 0;
                const firstProduct = this.products[0];
                if (firstProduct) {
                    const firstPriceWrap = firstProduct.querySelector(this.selectors.productPrice);
                    const firstQtyInput = firstProduct.querySelector(this.selectors.quantityInput);
                    const firstOriginPrice = parseInt(firstPriceWrap.getAttribute("data-price"), 10);

                    defaultOTP_Base = firstOriginPrice;
                    defaultOTP_Final = firstOriginPrice;

                    let firstSubBase = firstOriginPrice;
                    const spgJSON = JSON.parse(firstQtyInput.getAttribute('data-spgs'));
                    if (spgJSON && this.frequencySelect.length > 0) {
                        const selectedOption = this.querySelector(`${this.selectors.frequencySelect}`).selectedOptions[0];
                        if (selectedOption) {
                            const selectedName = selectedOption.getAttribute("data-name");
                            const sellingPlan = spgJSON.flatMap(item => item.selling_plans).find(plan => plan.name === selectedName);
                            if (sellingPlan) {
                                firstSubBase = Math.ceil(firstOriginPrice * (100 - sellingPlan.price_adjustments[0].value) / 100);
                            }
                        }
                    }
                    defaultSub_Base = firstOriginPrice;
                    defaultSub_Final = firstSubBase;
                }

                // --- 3. APPLY LOGIC ---
                const finalOTP_Regular = totalQuantity > 0 ? totalOTP_Final : defaultOTP_Final;
                const finalOTP_Compare = totalQuantity > 0 ? totalOTP_Base : defaultOTP_Base;
                const finalSub_Regular = totalQuantity > 0 ? totalSub_Final : defaultSub_Final;
                const finalSub_Compare = totalQuantity > 0 ? totalSub_Base : defaultSub_Base;

                // Update One-Time Preview Labels
                this.totalOTPRegularPrice.forEach(el => el.innerHTML = this.currencyFormatter.format(finalOTP_Regular / 100));
                this.totalOTPComparePrice.forEach(el => {
                    el.innerHTML = (finalOTP_Regular < finalOTP_Compare) ? this.currencyFormatter.format(finalOTP_Compare / 100) : "";
                });

                // Update Subscription Preview Labels
                this.totalSubRegularPrice.forEach(el => el.innerHTML = this.currencyFormatter.format(finalSub_Regular / 100));
                this.totalSubComparePrice.forEach(el => {
                    el.innerHTML = (finalSub_Regular < finalSub_Compare) ? this.currencyFormatter.format(finalSub_Compare / 100) : "";
                });

                // Update Main Checkout Totals
                const activeFinal = (this.interval === 'sub') ? totalSub_Final : totalOTP_Final;
                const activeBase = (this.interval === 'sub') ? totalSub_Base : totalOTP_Base;

                this.totalRegularPrice.forEach(el => el.innerHTML = this.currencyFormatter.format(activeFinal / 100));
                this.totalComparePrice.forEach(el => {
                    el.innerHTML = (activeFinal < activeBase) ? this.currencyFormatter.format(activeBase / 100) : "";
                });

                // General UI Updates
                this.discount.forEach(el => {
                    el.innerHTML = (totalQuantity >= totalQuantityMinThreshold && discountObject) ? `${discountObject.discount}% OFF` : "";
                });
                this.totalProducts.forEach(el => {
                    el.innerHTML = `(${totalQuantity} ${totalQuantity === 1 ? 'Bottle' : 'Bottles'})`;
                });

                this.setDiscountProgress(totalQuantity, discountObject);

                const discountActive = this.dataDiscounts?.discounts?.find(
                    d => d.quantity_max === this.totalQuantityMax
                );
                if(discountActive && this.bundleHeading) {
                    this.bundleHeading.forEach((el) => {
                        el.innerHTML = `Your bundle (${totalQuantity}/${Math.max(totalQuantity, discountActive?.quantity)})`;
                    })
                }
                if(totalQuantity == discountActive?.quantity){
                    this.sidebar?.classList.add('is-active');
                }
            }


        });
    }
})();